import S from 'common/service/sanctuary';
import React from 'react';
import { connect } from 'react-redux';
import { oneOf, shape, string } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import Menu, { MenuWrapper, MenuItem } from 'common/mdc/menu';
import Icon from 'common/mdc/icon';
import Button from 'common/mdc/button';

import {
  selectors,
} from 'common/store/server/links';

const NMS = Symbol('nms');
const SMAS = Symbol('smas');

const messages = defineMessages({
  nms: {
    id: 'app.selector.nms',
    defaultMessage: 'Network management',
  },
  smas: {
    id: 'app.selector.smas',
    defaultMessage: 'Smart metering',
  },
});

const AppSelector = ({ value, links }) => (
  <MenuWrapper
    overlay={false}
    wrappedElement={(
      <Button className="app-selector mdc-button--unelevated mdc-button--compact">
        {
          {
            [NMS]: <FormattedMessage {...messages.nms} />,
            [SMAS]: <FormattedMessage {...messages.smas} />,
          }[value]
        }
        <Icon className="mdc-button__icon">arrow_drop_down</Icon>
      </Button>
    )}
  >
    <Menu>
      {links.nms && (
        <MenuItem key="nms" onClick={() => { window.location = links.nms; }}>
          <FormattedMessage {...messages.nms} />
        </MenuItem>
      )}
      {links.sma && (
        <MenuItem key="smas" onClick={() => { window.location = links.sma; }}>
          <FormattedMessage {...messages.smas} />
        </MenuItem>
      )}
    </Menu>
  </MenuWrapper>
);

AppSelector.propTypes = {
  value: oneOf([NMS, SMAS]).isRequired,
  links: shape({
    nms: string,
    sma: string,
  }).isRequired,
};

AppSelector.NMS = NMS;
AppSelector.SMAS = SMAS;

export default connect(
  state => ({
    links: S.fromMaybe({}, selectors.getLinksMaybe(state)),
    loading: selectors.isLoading(state),
  }),
)(AppSelector);
